module.exports = __webpack_public_path__ + "static/media/social_media_linkin.5254c5d5.svg";